import * as MessageBar from "OfficeFabric/MessageBar";

export interface MessageBarWrapperProps extends MessageBar.IMessageBarProps {
    message: JSX.Element | string;

    onDidMount?: () => void;
}